const VERSION = "3.3.65";

export { VERSION };
